import React, { useMemo, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { secondAxios } from "../../../../../../../api/axios";
import SendToInventoryTable from "./table/SendToInventoryTable";

export default function SendToInventoryAction({
  selectedRowsData,
  setCompRows,
  selectedRows,
  disabled,
}) {
  const [open, setOpen] = useState(false);

  const [tableData, setTableData] = useState({});

  const initializeData = () => {
    setTableData(
      selectedRowsData.reduce(
        (acc, row) => ({
          ...acc,
          [row.key]: {
            spareQty: row?.left?.mrqMaterials?.[0]?.spareQty,
          },
        }),
        {},
      ),
    );
  };

  const handleOpen = () => {
    initializeData();
    setOpen(true);
  };

  const handleFieldChange = (rowKey, field, value) => {
    setTableData((prev) => ({
      ...prev,
      [rowKey]: {
        ...prev[rowKey],
        [field]: value,
      },
    }));
  };

  const handleConfirm = async () => {
    const payload = selectedRowsData.map((row) => ({
      id: row.left?.mrqMaterials?.[0]?.id,
      spareQty: tableData[row.key]?.spareQty || 0,
    }));

    const res = await secondAxios.patch("mrqMaterials/", payload);

    if (res?.data && Array.isArray(res.data)) {
      setCompRows((prev) =>
        prev.map((row) => {
          if (!selectedRows[row.key]) {
            return row;
          }

          const updatedMaterial = res.data.find(
            (item) => item.id === row.left?.mrqMaterials?.[0]?.id,
          );

          if (!updatedMaterial) {
            return row;
          }

          return {
            ...row,
            left: {
              ...row.left,
              mrqMaterials: [updatedMaterial],
            },
          };
        }),
      );
    }

    setOpen(false);
  };

  return (
    <>
      <Button variant="contained" disabled={disabled} onClick={handleOpen}>
        Send to inventory
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Send to Inventory</DialogTitle>

        <DialogContent>
          <SendToInventoryTable
            data={selectedRowsData}
            tableData={tableData}
            onDataChange={handleFieldChange}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>

          <Button variant="contained" onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
